import { Injectable, signal } from '@angular/core';

interface Toast {
    type: string;
    title: string;
    message: string;
    priceCard?: boolean;
}

@Injectable({
    providedIn: 'root',
})
export class ToastService {
    toasts = signal<Toast[]>([]);
    delay = 6000;

    add(toast: Toast) {
        this.toasts.update(t => [toast, ...t]);
        setTimeout(() => {
            this.toasts.update(t => t.filter(v => v !== toast));
        }, this.delay);
    }

    remove(index: number) {
        this.toasts.update(t => t.filter((_, i) => i !== index));
    }
}
